import "regenerator-runtime/runtime";
import _asyncToGenerator from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//封装接口使用
import _UseAxios from "./Axe";
import { Admin } from "@/assets/api/api"; //高级检索学科接口

export var getMMDL = function getMMDL(data) {
  return _UseAxios.get(Admin.getMMDL, data);
}; //高级检索学科接口

export var getXKLX = function getXKLX(data) {
  return _UseAxios.get(Admin.getXKLX, data);
}; //网站访问量接口

export var getAllSum = function getAllSum(data) {
  return _UseAxios.get(Admin.getAllSum, data);
}; //首页广告

export var GetFloatingAds = function GetFloatingAds(data) {
  return _UseAxios.get(Admin.GetFloatingAds, data);
}; //阅读/下载量接口

export var getOAViewTJ = function getOAViewTJ(data) {
  return _UseAxios.get(Admin.getOAViewTJ, data);
}; //高级检索栏目领域是否显示

export var getSFXS = function getSFXS(data) {
  return _UseAxios.get(Admin.getSFXS, data);
}; //年度区间接口

export var postNDCJ = function postNDCJ(data) {
  return _UseAxios.get(Admin.postNDCJ, data);
}; //高级检索栏目接口

export var getLM = function getLM(data) {
  return _UseAxios.get(Admin.getLM, data);
}; //注册

export var postRegist = function postRegist(data) {
  return _UseAxios.post(Admin.postRegist, data);
}; //发送验证码

export var getRegSendCode = function getRegSendCode(data) {
  return _UseAxios.get(Admin.getRegSendCode, data);
}; //密码找回

export var getForgetPassword = function getForgetPassword(data) {
  return _UseAxios.post(Admin.getForgetPassword, data);
};
export var getForgetPasswordGroup = function getForgetPasswordGroup(data) {
  return _UseAxios.post(Admin.getForgetPasswordGroup, data);
}; //找回密码页面添加相同邮箱和手机号所有账号列表

export var getIsRegistered = function getIsRegistered(data) {
  return _UseAxios.get(Admin.getIsRegistered, data);
};
export var getReSetPassword = function getReSetPassword(data) {
  return _UseAxios.get(Admin.getReSetPassword, data);
};
export var ForgetPasswordByGuid = function ForgetPasswordByGuid(data) {
  return _UseAxios.post(Admin.ForgetPasswordByGuid, data);
}; //判断手机号邮箱是否注册过

export var getRegDeteCt = function getRegDeteCt(data) {
  return _UseAxios.get(Admin.getRegDeteCt, data);
}; //页面初始化形成的验证码GUID

export var getVerificationcode = function getVerificationcode(data) {
  return _UseAxios.get(Admin.getVerificationcode, data);
}; //登录

export var postLogin = function postLogin(data) {
  return _UseAxios.post(Admin.postLogin, data);
}; //文献导出列表获取

export var getWZDC = function getWZDC(data) {
  return _UseAxios.get(Admin.getWZDC, data);
}; //

export var getDCJK = function getDCJK(data) {
  return _UseAxios.get(Admin.getDCJK, data);
}; //文章列表（栏目/学科/推荐/预出版/排行）《已完》

export var getXZPH = function getXZPH(data) {
  return _UseAxios.get(Admin.getXZPH, data);
}; //检索

export var postSearch = function postSearch(data) {
  return _UseAxios.post(Admin.postSearch, data);
}; //qq登录请求

export var postThirdRegister = function postThirdRegister(data) {
  return _UseAxios.post(Admin.postThirdRegister, data);
}; //获取轮播图

export var getBannerList = function getBannerList(data) {
  return _UseAxios.get(Admin.getBanner, data);
}; //

export var GetScriptPrePrintDetailed = function GetScriptPrePrintDetailed(data) {
  return _UseAxios.get(Admin.GetScriptPrePrintDetailed, data);
}; //期刊社动态/作者营地

export var getActor = function getActor(data) {
  return _UseAxios.post(Admin.getActor, data);
}; //友情链接

export var postFirend = function postFirend(data) {
  return _UseAxios.post(Admin.postFirend, data);
}; //期刊简介

export var getHeader = function getHeader(data) {
  return _UseAxios.post(Admin.getHeader, data);
}; //首页-最新一期列表

export var getNewlist = function getNewlist(data) {
  return _UseAxios.get(Admin.getNewlist, data);
}; //最新一期

export var getYear = function getYear(data) {
  return _UseAxios.get(Admin.getYear, data);
}; //首页封面，封底，目次打开文件

export var OpenGUIDFile = function OpenGUIDFile(data) {
  return _UseAxios.get(Admin.OpenGUIDFile, data);
};
export var OpenFilebyGuid = function OpenFilebyGuid(data) {
  return _UseAxios.get(Admin.OpenFilebyGuid, data);
};
export var OpenMessageFilebyGuid = function OpenMessageFilebyGuid(data) {
  return _UseAxios.get(Admin.OpenMessageFilebyGuid, data);
}; // 下载pdf
// export const getPDF = (data) => {
//     return _UseAxios.down(Admin.getPDF, data);
// }

export var getPDF = function getPDF(data) {
  return _UseAxios.get(Admin.getPDF, data);
};
export var getPDFnew = function getPDFnew(data) {
  return _UseAxios.get(Admin.getPDFnew, data);
};
export var getPDFfile = function getPDFfile(data) {
  return _UseAxios.get(Admin.getPDFfile, data);
}; //html次数+1

export var getHtmlRead = function getHtmlRead(data) {
  return _UseAxios.get(Admin.getHtmlRead, data);
}; //预初版

export var getList = function getList(data) {
  return _UseAxios.get(Admin.getList, data);
};
export var getLista = function getLista(data) {
  return _UseAxios.get(Admin.getLista, data);
};
export var getListb = function getListb(data) {
  return _UseAxios.get(Admin.getListb, data);
};
export var getXZCS = function getXZCS(data) {
  return _UseAxios.get(Admin.getXZCS, data);
};
export var getLBXQ = function getLBXQ(data) {
  return _UseAxios.get(Admin.getLBXQ, data);
};
export var getdownXML = function getdownXML(data) {
  return _UseAxios.get(Admin.getdownXML, data);
};
export var getPLLB = function getPLLB(data) {
  return _UseAxios.post(Admin.getPLLB, data);
};
export var postMassage = function postMassage(data) {
  return _UseAxios.post(Admin.postMassage, data);
};
export var getgok = function getgok(data) {
  return _UseAxios.get(Admin.getgok, data);
};
export var getSet = function getSet(data) {
  return _UseAxios.post(Admin.getSet, data);
};
export var getLLCS = function getLLCS(data) {
  return _UseAxios.get(Admin.getLLCS, data);
};
export var getdetailes = function getdetailes(id) {
  return _UseAxios.get(Admin.getdetailes + '/' + id);
};
GetRss;
export var GetRss = function GetRss(data) {
  return _UseAxios.get(Admin.GetRss, data);
};
GetRssycb;
export var GetRssycb = function GetRssycb(data) {
  return _UseAxios.get(Admin.GetRssycb, data);
};
GetscriptRssycb;
export var GetscriptRssycb = function GetscriptRssycb(data) {
  return _UseAxios.get(Admin.GetscriptRssycb, data);
};
export var IssueDownLoad = function IssueDownLoad(data) {
  return _UseAxios.down(Admin.IssueDownLoad, data);
}; // 高级检索栏目领域是否显示
//     getSFXS: query => get('api/Common/GetSetItem', query),
//     //标题接口
//     getBT: query => post('api/Common/GETSetItems', query),
//     //头部导航栏
//     getHeader: query => post('api/Document/GetFixedItemBodys', query),
//     //文章浏览次数s
//     getLLCS: query => get('api/Web/IncView_Times', query),
//     //文档浏览次数
//     getWZCS: query => get('api/Document/Hits', query),
//     //下载次数
//     getXZCS: query => get('api/Web/IncArticleRead_Times', query),
//     //首页轮播接口
//     getBanner: query => get('api/Common/GetLoopItem', query),
//     //获取期数据接口
//     getYear: query => get('api/Web/GetIssue', query),
//     //获取导出接口
//     getDC: query => get('api/Web/GetIssue', query),
//     //获取首页列表预出版接口
//     getList: query => get('api/Common/GetSetItem', query),
//     getLista: query => get('api/Web/PreprintList', query),
//     getListb: query => get('api/Web/OAList', query),
//     //获取首页列表最新一期接口
//     getNewlist: query => get('api/Web/LastIssueList', query),
//     //过刊目录列表接口
//     getgok: query => get('api/Web/GetCatalog', query),
//     //高级检索学科领域接口
//     getXKLX: query => get('api/Common/GetDictList', query),
//     //下载PDF接口
//     getPDF: query => get('api/Web/ArticleDownLoad', query),
//     //高级检索栏目接口
//     getLM: query => get('api/Common/GetOAColumnDictList', query),
//     //投稿须知
//     getTGXZ: query => get('api/Document/GetFixedItemBodys', query),
//     //期封面、封底、目次下载接口
//     getGGM: query => get('api/Web/IssueDownLoad', query),
//     //期数据接口
//     getQSJ: query => get('api/Web/GetIssue', query),
//     //导出接口
//     getDCJK: query => get('api/Web/ExportFormat', query),
//     //首页总访问数
//     getFWZS: query => get('api/PageVisit/GetVisitCount', query),
//     //文章导出接口
//     getWZDC: query => get('api/Web/ExportList', query),
//     //下载排行接口
//     getXZPH: query => get('api/Web/OAList', query),
//     //列表详情接口
//     getLBXQ: query => get('api/Web/GetArticleDetailed', query),
//     //作者园地接口
//     getActor: query => post('api/Document/GetDocumentList', query),
//     //期刊社公告接口
//     getTELL: query => post('api/Document/GetDocumentList', query),
//     //文章检索接口
//     postSearch: query => post('api/Web/ArticleSearch', query),
//     //发表评论接口
//     postMassage: query => post('api/Comments/Item', query),
//     //评论列表接口
//     getPLLB: query => post('api/Comments/GetCommentList', query),
//     //友情链接接口
//     postFirend: query => post('api/Links/GetLinks', query),
//     //作者园地详情
//     postZZYD: query => get('api/Document/GetDetailed', query),
//     //年度区间接口
//     postNDCJ: query => get('api/common/GetPublishYearList', query),
//     // //bai
//     //发送验证码
//     getRegSendCode: query => get('api/CRCActiveRecord/Verificationcode', query),
//     //验证用户邮箱手机号是否已注册
//     getRegDeteCt: query => get('api/Account/IsRegistered', query),
//     //注册
//     postRegist: query => post('api/Account/Register', query),
// 	postThirdRegister1:query =>post('api/Account/ThirdRegister', query),
//     //登录
//     postLogin: query => post('api/Account/Login',query),
//     //页面初始化形成验证码以及GUID
//     getVerificationcode : query => get('api/Account/Verificationcode',query),
//     //忘记密码
//     getForgetPassword : query => post('api/Account/ForgetPassword',query),
//     aaaa : query => get('api/Document/GetDetailed',query),

export var getGetQrcode = function getGetQrcode(data) {
  return _UseAxios.get(Admin.getGetQrcode, data);
};
export var getWeiXinLogin = function getWeiXinLogin(data) {
  return _UseAxios.get(Admin.getWeiXinLogin, data);
};
export var GetRouter =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _UseAxios.get(Admin.GetRouter));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function GetRouter() {
    return _ref.apply(this, arguments);
  };
}();
export var GetToken = function GetToken(data) {
  return _UseAxios.get(Admin.GetToken, data);
};
export var EamilVerification = function EamilVerification(data) {
  return _UseAxios.get(Admin.EamilVerification, data);
};
export var NoLoginChangePassword = function NoLoginChangePassword(data) {
  return _UseAxios.post(Admin.NoLoginChangePassword, data);
};
export var GetYearIssueList = function GetYearIssueList(data) {
  return _UseAxios.get(Admin.GetYearIssueList, data);
};
export var GetArticleIDByNum = function GetArticleIDByNum(data) {
  return _UseAxios.get(Admin.GetArticleIDByNum, data);
};
export var PostSubscribe = function PostSubscribe(data) {
  return _UseAxios.get(Admin.PostSubscribe, data);
};
export var UnSubscribe = function UnSubscribe(data) {
  return _UseAxios.get(Admin.UnSubscribe, data);
};
export var GetIssueList = function GetIssueList(data) {
  return _UseAxios.post(Admin.GetIssueList, data);
};